const callbacks = {};

function on(event, callback, opts) {
	!callbacks[event] & (callbacks[event] = []);
	
	if(callbacks.hasOwnProperty(event))
	{
		callbacks[event].push({ event, callback });
		document.addEventListener(event, callback, opts);
	}
}

function emit(event, params){
	document.dispatchEvent(new CustomEvent(event, {detail:params}));
}

function remove(eventName){
	for(let key in callbacks){
		if(key == eventName){
			while(callbacks[key].length>0){
				let item = callbacks[key].pop();
				document.removeEventListener(item.event, item.callback);
			}
		}
	}
}

function unload(){
	for(let key in callbacks){
		while(callbacks[key].length>0){
			let item = callbacks[key].pop();
			document.removeEventListener(item.event, item.callback);
		}
	}
}

export default {
	on,
	emit,
	remove,
	unload,
}